export default __webpack_public_path__ + "static/renshin-animation-4c07b3a3ec0f6af6154c0452eddc31a2.webm";